<template>
  <div class="container" id="matiPage">
    <div class="counter">
      <span class="count">{{ counter }}</span>
      / {{ length }}
    </div>
    <h2>待ち・雀頭・アガリ方<br />に付くのは何符ですか？</h2>
    <div class="text-wrapper">
      <div class="d-flex mt-5">
        <span class="kyoku-text">東場南家</span>
      </div>
      <div class="d-flex justify-end">
        <span class="agari-text" v-if="quiz[counter].agari === 0">ロン</span>
        <span class="agari-text" v-else>ツモ</span>
      </div>
    </div>
    <div class="quiz-info d-flex justify-space-between">
      <div class="tehai d-flex justify-center">
        <div v-for="(pai, index) in quiz[counter].tehaiImgs" :key="index">
          <img class="pai" :src="pai + '.jpg'" />
        </div>
      </div>
      <img class="pai" :src="quiz[counter].mati + '.jpg'" />
    </div>
    <div class="btn-answer-area d-flex justify-space-between flex-wrap">
      <v-btn class="btn-answer blue darken-1 white--text" @click="goNext(0)"
        >0</v-btn
      >
      <v-btn class="btn-answer blue darken-1 white--text" @click="goNext(2)"
        >2</v-btn
      >
      <v-btn class="btn-answer blue darken-1 white--text" @click="goNext(4)"
        >4</v-btn
      >
      <v-btn class="btn-answer blue darken-1 white--text" @click="goNext(6)"
        >6</v-btn
      >
    </div>
    <div class="judgement" v-if="!isHidden">
      <v-icon color="red accent-3" v-if="judgement">
        mdi-checkbox-blank-circle-outline
      </v-icon>
      <v-icon color="red accent-3" v-else>
        mdi-close
      </v-icon>
    </div>
  </div>
</template>

<script>
import matiMap from "../assets/matiMap.json";

export default {
  name: "Mati",
  data() {
    return {
      length: 10,
      counter: 1,
      correct: 0,
      judgement: false,
      isHidden: true,
      quiz: [],
      timer: 0,
      timerObj: null,
      imgPath: "none.jpg",
    };
  },
  methods: {
    goNext(num) {
      console.log(
        `counter${this.counter}:選択${num}:答え${
          this.quiz[this.counter].answer
        }`
      );
      console.log(`選択${num}:答え${this.quiz[this.counter].answer}`);

      // 正解だった場合
      if (num === this.quiz[this.counter].answer) {
        this.correct += 1;
        this.judgement = true;
        //   correct.play();
        console.log("正解");
      } else {
        this.judgement = false;
        //   wrong.play();
      }
      // 正誤判定を表示
      this.isHidden = false;
      // 一定時間後に正誤判定を非表示
      setTimeout(this.hidden, 300);

      // 次のページを表示
      if (this.counter < this.length) {
        this.counter += 1;
      } else {
        // 問題が解き終わったら結果ページへ遷移
        this.$router.push({
          name: "matiResult",
          query: {
            counter: this.counter,
            correct: this.correct,
            timer: this.timer,
          },
        });
      }
    },
    // 正誤判定を非表示にする
    hidden() {
      this.isHidden = true;
    },
  },
  created() {
    this.length = 10;
    this.timer = 0;
    this.timerObj = null;
    // this.quiz = kotsuMap;

    // 手牌の配列から画像のアドレスの配列に変換
    const newQuiz = matiMap.map(function(item) {
      let tehaiArr = item.tehai.match(/.{2}/g);
      // const tehaiImgs = tehaiArr.map(function(pai) {
      //   switch (pai) {
      //     case "1z":
      //       return "ton";
      //     case "2z":
      //       return "nan";
      //     case "3z":
      //       return "sya";
      //     case "4z":
      //       return "pe";
      //     case "5z":
      //       return "haku";
      //     case "6z":
      //       return "hatsu";
      //     case "7z":
      //       return "tyun";
      //     default:
      //       return pai;
      //   }
      // });
      // console.log(tehaiImgs);

      return {
        tehaiImgs: tehaiArr,
        mati: item.mati,
        agari: item.agari,
        answer: item.answer,
      };
    });

    // ランダムに並び替える関数
    const shuffle = ([...array]) => {
      console.log(array.length);
      console.log(array);
      for (let i = array.length - 1; i >= 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    };
    // シャッフル実行
    this.quiz = shuffle(newQuiz);
  },
  mounted() {
    this.imgPath = this.quiz[this.counter].pai + ".jpg";

    this.timer = Number(0);
    this.timerObj = setInterval(() => {
      this.timer += 1;
      // console.log(this.timer);
    }, 100);
  },
  beforeDestroy: function() {
    clearInterval(this.timerObj);
    this.timerObj = null;
  },
};
</script>

<style lang="scss">
#matiPage {
  &.container {
    padding-top: 20px;
  }
  h2 {
    text-align: center;
    margin: 12px 0;
    font-size: 1.5rem;
    line-height: 1.2;
  }
  .counter {
    text-align: left;
    position: relative;
    top: 0px;
    left: 10px;
    font-size: 20px;
    .count {
      font-size: 24px;
      font-weight: bold;
    }
  }
  .text-wrapper {
    max-width: 400px;
    margin: 0 auto;
    .kyoku-text {
      font-size: 1.5rem;
    }
    .agari-text {
      width: 54px;
      margin-right: 4px;
      font-size: 1.5rem;
    }
  }
  .quiz-info {
    height: 100px;
    max-width: 400px;
    font-size: 28px;
    margin: 0 auto;
    margin-top: 0px;
    .pai {
      //   width: 16%;
      //   height: auto;
      width: 54px;
      height: 69px;
      margin-right: 4px;
      border: 1px solid #ccc;
      border-radius: 10%;
    }
  }
  .btn-answer-area {
    width: calc(100% - 40px);
    max-width: 400px;
    margin: 2rem auto 0rem;
    position: fixed;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    .btn-answer {
      width: 48%;
      height: 52px;
      font-size: 1.6rem;
      margin-bottom: 0.5rem;
    }
  }
  .judgement {
    width: calc(100% - 40px);
    position: fixed;
    top: 200px;
    left: 50%;
    transform: translateX(-50%);
    i {
      font-size: 180px;
    }
    animation: fadeout-keyframes 0.5s;
  }
  @keyframes fadeout-keyframes {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }
}
</style>
